import React, { useCallback, useState, useEffect } from "react";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";

import { i18nSolfa, getSolfaName, lengthenSolfa } from "../../../../../../common/parameters";
import { IBar, IPitch, IScore } from "../../../../../../common/types";

import { Button } from "../../Intervals/IntervalsLadder/IntervalButton/styles";

import { Container, Modal, DemoContainer, DragSimulator } from "./styles";
import messages from "./messages";
import { get, set } from "./store";
import { IProps } from "./interfaces";
import { useSelector } from "react-redux";
import { IStateTree } from "../../../../../store/interfaces";
import { IUser } from "../../../../../store/user/models";

const getAlteredSolfaName = (score: IScore, locale: string, solfaShort: boolean, solfaKam: boolean) => {
    for (let v = 0; v <= 6; v++) {
        const bars = score[`bars${v || ""}`] as IBar[];
        if (!bars) continue;
        for (let b = 0; b <= bars.length; b++) {
            const bar = bars[b];
            if (!bar) continue;
            for (let n = 0; n <= bar.notes.length; n++) {
                const note = bar.notes[n];
                if ((note?.p as IPitch)?.a === 1 || (note?.p as IPitch)?.a === -1) {
                    return {
                        alteredSolfaName: lengthenSolfa(i18nSolfa(getSolfaName(note.p as IPitch, locale), locale, solfaKam), locale, solfaShort),
                        normalSolfaName: lengthenSolfa(i18nSolfa(getSolfaName({ ...note.p, a: 0 } as IPitch, locale), locale, solfaKam), locale, solfaShort),
                        direction: (note.p as IPitch).a === 1 ? "right" : "left",
                    };
                }
            }
        }
    }
    return {
        alteredSolfaName: null,
    };
};

const DragHintModal = ({ score }: IProps) => {
    const { locale } = useIntl()
    const [isVisible, setVisible] = useState(false);
    const { solfaShort = false, solfaKam = false } = useSelector(({ user }: IStateTree) => user as IUser);
    const handleClick = useCallback(() => {
        set();
        setVisible(false);
    }, []);

    useEffect(() => {
        if (!get()) {
            setVisible(true);
        }
    }, []);

    if (!isVisible) return null;
    const { alteredSolfaName, normalSolfaName, direction } = getAlteredSolfaName(score, locale, solfaShort, solfaKam);
    if (!alteredSolfaName) return null;
    return (
        <Container>
            <Modal>
                <p>
                    <FormattedMessage
                        {...messages[direction === "left" ? "hintLeft" : "hintRight"]}
                        values={{
                            alteredSolfaName: <b><span dangerouslySetInnerHTML={{ __html: alteredSolfaName.replace("b", "<i>b</i>") }} /></b>,
                            solfaName: <b>{normalSolfaName}</b>,
                        }}
                    />
                </p>
                <DemoContainer>
                    <DragSimulator isLeft={direction === "left"}>
                        <Button className="Button">
                            <span className="Normal">{normalSolfaName}</span>
                            <span className="Altered" dangerouslySetInnerHTML={{ __html: alteredSolfaName.replace("b", "<i>b</i>") }}/>
                        </Button>
                    </DragSimulator>
                </DemoContainer>
                <button className="button button--full-width" onClick={handleClick}>
                    <FormattedMessage {...messages.close} />
                </button>
            </Modal>
        </Container>
    );
};

export default DragHintModal;
